<template>
  <div :class="{
          loading: true,
          overlay: overlay,
        }">
    <p-vue-progress-spinner strokeWidth="3"
                            class="progress"
                          />
  </div>
</template>

<script>

import PVueProgressSpinner from 'primevue/progressspinner';

export default {
  props: {
    overlay: Boolean,
  },
  components: {
    PVueProgressSpinner,
  },
}
</script>

<style scoped>

  .loading {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    position: absolute;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.1);;
  }

  .loading.overlay {
    position: fixed;
  }

  .progress {
    width: 50px;
    height: 50px;
  }

</style>